import { PersonAvatar, initials } from 'components/person-avatar';
import { User } from 'types/user';

/** Como o colega é chamado nos títulos: o nome de guerra ou, sem ele, o primeiro nome. */
export function colleagueShortName(person?: User) {
  return person?.extra?.nome_guerra || person?.name?.split(' ')[0] || '';
}

/** Lotação do colega: dependência e função, com o que houver. */
export function colleaguePlacement(person: User) {
  return [person.extra?.dependencia, person.extra?.funcao].filter(Boolean).join(' · ');
}

/** Rosto do colega (avatar montado, foto ou iniciais), pela regra do `PersonAvatar`. */
export function ColleagueAvatar({ person }: { person: User }) {
  return (
    <PersonAvatar
      image={person.image?.small?.url}
      avatar={person.extra?.avatar}
      avatarType={person.extra?.avatar_type}
      initials={initials(person.name)}
    />
  );
}
